import { useEffect, useState } from "react";
import { Button, Caption1, Spinner, makeStyles, tokens } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import type { ImageItem } from "@app/sp-data";
import { useData } from "../data/DataProvider";

const useStyles = makeStyles({
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(96px, 1fr))", gap: tokens.spacingHorizontalS },
  thumb: {
    width: "100%",
    aspectRatio: "1",
    objectFit: "cover",
    borderRadius: tokens.borderRadiusMedium,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    cursor: "zoom-in",
    display: "block",
  },
  thumbBtn: { padding: 0, border: "none", background: "none" },
  viewer: {
    position: "fixed",
    inset: 0,
    zIndex: 100,
    backgroundColor: "rgba(0,0,0,0.9)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  full: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" },
  close: { position: "absolute", top: "8px", right: "8px", color: "white" },
});

/** Foto di una richiesta (cartella con il suo ID nella raccolta "Foto richieste"). */
export function PhotoGallery({ richiestaId }: { richiestaId: number }) {
  const s = useStyles();
  const { foto } = useData();
  const [items, setItems] = useState<ImageItem[]>();
  const [error, setError] = useState(false);
  const [open, setOpen] = useState<ImageItem>();

  useEffect(() => {
    foto.listImages(String(richiestaId)).then(setItems, () => setError(true));
  }, [foto, richiestaId]);

  if (error) return <Caption1>Non è stato possibile caricare le foto.</Caption1>;
  if (!items) return <Spinner size="tiny" />;
  if (!items.length) return <Caption1>Nessuna foto.</Caption1>;

  return (
    <>
      <div className={s.grid}>
        {items.map((it) => (
          <button key={it.id} type="button" className={s.thumbBtn} onClick={() => setOpen(it)} aria-label={`Apri ${it.name}`}>
            <img className={s.thumb} src={it.thumbnails.medium?.url ?? it.thumbnails.small?.url} alt={it.name} loading="lazy" />
          </button>
        ))}
      </div>
      {open && (
        <div className={s.viewer} role="dialog" aria-label="Foto" onClick={() => setOpen(undefined)}>
          <img className={s.full} src={open.thumbnails.large?.url ?? open.thumbnails.medium?.url} alt={open.name} />
          <Button className={s.close} appearance="transparent" icon={<Dismiss24Regular />} aria-label="Chiudi" />
        </div>
      )}
    </>
  );
}
